// extracted by mini-css-extract-plugin
module.exports = {"root":"_2lPBL","mobile":"_3jNbW"};